import { NgClass } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ImageBannerComponent } from '../../components/image-banner/image-banner.component';
import { ProjectCardComponent } from '../../components/project-card/project-card.component';
import { ProjectCirclesComponent } from '../../includes/project-circles/project-circles.component';
import { SeatBeltComponent } from '../../components/seat-belt/seat-belt.component';
import { Router, NavigationEnd } from '@angular/router';
import { ProjectService } from '../../services/project.service';
import { MetaService } from '../../services/meta.service';

@Component({
  selector: 'pc-projects',
  standalone: true,
  imports: [
    ImageBannerComponent,
    ProjectCardComponent,
    ProjectCirclesComponent,
    SeatBeltComponent,
    NgClass
  ],
  templateUrl: './projects.component.html',
  styleUrl: './projects.component.scss'
})
export class ProjectsComponent implements OnInit {
  // Banner Image
  bannerImgUrl: string | undefined;
  // Projects
  // projectList: ProjectCardComponent[] = [];
  projectList: any[] = [];
  // Sort
  openFilters: boolean | undefined;
  sortNewest: boolean | undefined;
  sortOldest: boolean | undefined;
  sortAtoZ: boolean | undefined;
  sortZtoA: boolean | undefined;

  constructor(
    private router: Router,
    private projectService: ProjectService,
    private metaService: MetaService
  ) { }

  ngOnInit(): void {
    this.metaService.setMetadata('projects');

    // Make sure we're at top of page
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });
    
    // Banner Image
    this.bannerImgUrl = 'https://tsgblob.blob.core.windows.net/pc-haines/assets/images/projects/banner';

    this.projectService.getProjects().subscribe((projects: any[]) => {
      this.projectList = projects.map(project => ({
        ...project,
        projectDate: project.projectDate ? new Date(project.projectDate) : undefined
      }));
      this.sortProjectsByNewesttDate();
    });

    this.sortProjectsByNewesttDate();
  }

  sortProjectsTitleAtoZ(): void {
    this.sortNewest = false;
    this.sortOldest = false;
    this.sortAtoZ = true;
    this.sortZtoA = false;
    this.projectList.sort((a, b) => a.title.localeCompare(b.title));
    this.closeFilters();
  }
  sortProjectsTitleZtoA(): void {
    this.sortNewest = false;
    this.sortOldest = false;
    this.sortAtoZ = false;
    this.sortZtoA = true;
    this.projectList.sort((b, a) => a.title.localeCompare(b.title));
    this.closeFilters();
  }

  sortProjectsByOldestDate(): void {
    this.sortNewest = false;
    this.sortOldest = true;
    this.sortAtoZ = false;
    this.sortZtoA = false;
    this.projectList.sort((a, b) => a.projectDate.getTime() - b.projectDate.getTime());
    this.closeFilters();
  }
  sortProjectsByNewesttDate(): void {
    this.sortNewest = true;
    this.sortOldest = false;
    this.sortAtoZ = false;
    this.sortZtoA = false;
    this.projectList.sort((a, b) => b.projectDate.getTime() - a.projectDate.getTime());
    this.closeFilters();
  }
  trackByFn(index: number, project: any): number {
    return project.projectDate.getTime(); // or any unique identifier
  }

  toggleFilter() {
    this.openFilters = !this.openFilters;
  }
  closeFilters() {
    this.openFilters = false;
  }
}
